export default __webpack_public_path__ + "static/media/26.fe34705a.jpg";